import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import SectionTitle from "./SectionTitle";
import MiniCard from "./MiniCard";
import SliderLine from "./SliderLine";

const CARDS = [
  { titleKey: "security.card1.title", textKey: "security.card1.text" },
  { titleKey: "security.card2.title", textKey: "security.card2.text" },
  { titleKey: "security.card4.title", textKey: "security.card4.text" },
  { titleKey: "security.card3.title", textKey: "security.card3.text" },
];

function Security() {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  const [current, setCurrent] = useState(0);

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="flex flex-col sm:flex-row sm:items-start gap-[25px] sm:gap-[40px] lg:gap-[62px]">
          {/* Слева: заголовок */}
          <div className="sm:flex-1">
            <SectionTitle
              title1={t("security.title1")}
              title2={t("security.title2")}
              text={t("security.subtitle")}
              align="left"
            />
          </div>

          {/* Справа: 2x2 карточки (desktop) */}
          <div className="hidden sm:grid grid-cols-2 gap-[20px] sm:w-[62%] lg:w-[718px] shrink-0">
            {CARDS.map((card, i) => (
              <MiniCard key={i} title={t(card.titleKey)} text={t(card.textKey)} />
            ))}
          </div>

          {/* Мобильный слайдер */}
          <div className="sm:hidden w-full">
            <Swiper
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => setCurrent(swiper.realIndex)}
              spaceBetween={16}
              slidesPerView={1}
              grabCursor
            >
              {CARDS.map((card, i) => (
                <SwiperSlide key={i}>
                  <MiniCard title={t(card.titleKey)} text={t(card.textKey)} />
                </SwiperSlide>
              ))}
            </Swiper>
            <SliderLine
              current={current}
              total={CARDS.length}
              onPrev={() => swiperRef.current?.slidePrev()}
              onNext={() => swiperRef.current?.slideNext()}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Security;
